<template>
  <div id="app">
     <!-- 关注公众号 -->
    <van-overlay :show="showFocus" class-name="topIndex" >
      <div class="wrapper2" @click.stop>
        <div class="content2">
          <img :src="env==='wwjrxx'? 'https://dstatic.wwjrxx.com/image/static/wwjrxx_gzh_logo.jpg':'https://dstatic.wwjrxx.com/image/static/wwgd_gzh_logo.jpg'"/>
          <van-icon name="close" color="#fff" size="30px" @click="showFocus=false"/>
        </div>
      </div>
    </van-overlay>
    <div class="app app1">
      <sticky-header v-if="$route.meta.showHead"/>
      <keep-alive :include="['score-center', 'score-record', 'order']">
        <router-view v-if="$route.meta.keepAlive" />
      </keep-alive>
      <div class="moment-login" :style="`top:${$route.meta.top}px;height:calc(100vh - ${$route.meta.showTab? $route.meta.top+50 : $route.meta.top}px)`" v-if="getShow()">
        <img src="./assets/user/login.png"/>
        <van-button class="mo-btn" @click="toLogin()" size="small" block>立即登录</van-button>
      </div>
      <nav-bar v-if="$route.meta.showTab"></nav-bar>
      <router-view v-if="!$route.meta.keepAlive" />
    </div>
  </div>
</template>

<script>
import navBar from "@/components/navBar.vue";
import StickyHeader from '@/components/StickyHeader.vue'
import { checkIsLogin, getCookie, getStorage, removeStorage, setStorage } from './utils/common';
import { getUserInfo } from './service/user';
import { refer } from './utils/routerFun';
import { getEnvValue } from './service/common';

export default {
  name: "App",
  components: {
    "nav-bar": navBar,
    "sticky-header": StickyHeader,
  },
  data(){
    return {
      isLogin: checkIsLogin(),
      momentLogin: false,
      show: getStorage('cancelLogin'),
      showFocus: false,
      prod: false,
      env: getStorage('env')
    }
  },
  async mounted() {
    console.log('app 开始');
    window.onresize = ()=>{
      document.documentElement.style.fontSize = `calc(${(100 /(document.body.clientWidth * 2)) *100}vw)`;
    }
    document.documentElement.style.fontSize = `calc(${
      (100 / (document.body.clientWidth * 2)) * 100
    }vw)`;
    window.onresize = () => {
      document.documentElement.style.fontSize = `calc(${
        (100 / (document.body.clientWidth * 2)) * 100
      }vw)`;
    };
    if (
      typeof WeixinJSBridge == "object" &&
      // eslint-disable-next-line no-undef
      typeof WeixinJSBridge.invoke == "function"
    ) {
      handleFontSize();
    } else {
      document.addEventListener("WeixinJSBridgeReady", handleFontSize, false);
    }
    function handleFontSize() {
      // 设置网页字体为默认大小
      // eslint-disable-next-line no-undef
      WeixinJSBridge.invoke("setFontSizeCallback", { fontSize: 0 });
      // 重写设置网页字体大小的事件
      // eslint-disable-next-line no-undef
      WeixinJSBridge.on("menu:setfont", function () {
        // eslint-disable-next-line no-undef
        WeixinJSBridge.invoke("setFontSizeCallback", { fontSize: 0 });
      });
    }
    refer()
  },
  methods:{
    getShow(){
      return getStorage('cancelLogin') && this.$route.path!=='/user'&& this.$route.path!=='/login'
    },
    async getNewUser(){
      let user = await getUserInfo()
      if(!user.isFocus){
        this.showFocus = true
        this.getEwm()
      }
    },
    getEwm(){
      this.prod = process.env.VUE_APP_ENV==='prod'?  true: false
    },
    check(){
      this.show = getStorage('liveuser') && getCookie('t')
      return getStorage('liveuser') && getCookie('t')
    },
    cancelHandle(){
      this.isLogin = true
      this.show = true
    },
    toLogin(){
      this.show = false
      removeStorage('cancelLogin')
      const { query, fullPath } = this.$route
      const {url} = query
      console.log('this.$route', this.$route);
      let redirUrl = url? "https://" + location.host + url : "https://" + location.host + fullPath
      console.log('redirUrl', redirUrl);
      this.$router.push({
				path: '/login',
				query: {
          url: redirUrl
        }
			})
    },
  }
};
</script>

<style lang="less">
@import url("./styles/index.less");
@import url("./styles/iconfont.css");
@import url("./styles/ali-font.css");
#app, .app {
  // background-color: #f5f7fa;
  max-width: 640px;
  margin: 0 auto;
  height: calc(100vh + env(safe-area-inset-bottom));
}
/*修改滚动条样式*/
div::-webkit-scrollbar {
  width: 0px;
  height: 10px;
  /**/
}
div::-webkit-scrollbar-track {
  background: rgb(239, 239, 239);
  border-radius: 2px;
}
div::-webkit-scrollbar-thumb {
  background: #bfbfbf;
  border-radius: 10px;
}
div::-webkit-scrollbar-thumb:hover {
  background: #333;
}
div::-webkit-scrollbar-corner {
  background: #179a16;
}
.xgplayer-skin-default .xgplayer-definition {
  margin-left: -12px !important;
}
.buycode .van-image__img {
  width: 50%;
  min-width: 200px;
  margin-left: 25%;
}
.buycode .van-icon-clear{
  position: absolute;
  top:0;
  left:0
}
.van-image-preview__overlay {
  background-color: rgba(0, 0, 0, 0.8) !important;
}
// *{touch-action: none;}
.header-bar .van-nav-bar__content{
  height: 20px;
}
.moment-login{
  position: absolute;
  width: 100%;
  background: #fff;
  text-align: center;
  top: 80px;
  z-index: 999;
  max-width: 640px;
  img{
    width: 200px;
    display: block;
    margin: 0 auto;
  }
  .mo-btn{
    width: 50%;
    margin: 0 auto;
  }
}
 .wrapper2 {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }
 .content2 {
    background-color: #fff;
    width: 260px;
    height: 260px;
    text-align: center;
  }

.content2 img{
  width: 100%;
}
.topIndex{
  z-index:9999 !important;
}
</style>
